package user.containers

import antd.message.message
import com.jingfangpai.api.clients.UserApiClient
import com.jingfangpai.user.model.UserAuthData
import kotlinx.browser.window
import user.components.loginComponent
import user.service.AuthService
import react.*
import react.dom.div
import setTitle

external interface LoginPageProps:RProps {
    var redirectUrl:String?
}

val LoginPageContext = createContext("")

val LoginProvider = functionalComponent<LoginPageProps> {
        props->

    setTitle("登录")

    val (errorMessage,setErrorMessage) = useState("")

    fun onLogin(userName:String,password:String){
         console.log(userName,password)
        val hide = message.loading("正在登录中，请稍候...")
        UserApiClient.login(userName,password,{
            apiResponse ->
            window.setTimeout(hide,1)
            if(apiResponse.ok()){
                if(apiResponse.data!=null){
                    AuthService.setUserAuthData(apiResponse.data!!,apiResponse.data!!.jwt?:"")
                    if(!props.redirectUrl.isNullOrBlank()){
                        window.location.href = props.redirectUrl!!
                    }else{
                        window.location.href = "/"
                    }
                }else{
                    setErrorMessage("登录失败了,返回的授权信息为空")
                }
            }else{
               setErrorMessage("登录失败了,${apiResponse.message}")
            }
        },{setErrorMessage("登录失败了,${it.message}")})
    }

    fun onTyping(){
        setErrorMessage("");
    }

    LoginPageContext.Provider(errorMessage) {
        div("login-page") {
            loginComponent(::onLogin,::onTyping)
        }
    }
}

fun RBuilder.loginPage(redirectUrl:String) {
    child(LoginProvider){
        attrs.redirectUrl = redirectUrl
    }
}
